<template>
    <div class="content-wrapper">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">
                        <i class="fa fa-home"></i>
                        Dashboard
                    </a>
                </li>
                <li class="breadcrumb-item active">Vendors</li>
                <li v-can="'vendors.create'" class="breadcrumb-right">
                    <router-link to="/vendors/create" class="btn btn-sm btn-success">
                        <i class="fa fa-plus"></i>
                        New Vendor
                    </router-link>
                </li>
            </ol>
        </nav>
        <section class="content">
            <div class="container-fluid">
                <div class="row justify-content-md-center">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Vendors</h3>
                                <div class="card-tools">
                                    <div class="custom-control custom-switch custom-switch-off-success custom-switch-on-danger">
                                        <input type="checkbox" class="custom-control-input" id="trashed" v-model="meta.trashed" @click="isTrashed" />
                                        <label class="custom-control-label" for="trashed">Trashed</label>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <input class="form-control form-control-sm" type="text" placeholder="Search" v-model="meta.search" @keyup="search" />
                                </div>
                                <table class="table table-responsive-sm table-bordered table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th @click="sort('vendor_no')">Vendor No
                                                <span>
                                                    <i v-if="meta.keyword=='vendor_no' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='vendor_no' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('vendor_name')">Company Name
                                                <span>
                                                    <i v-if="meta.keyword=='vendor_name' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='vendor_name' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('contact_person')">Contact Person
                                                <span>
                                                    <i v-if="meta.keyword=='contact_person' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='contact_person' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('mobile_no')">Mobile No
                                                <span>
                                                    <i v-if="meta.keyword=='mobile_no' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='mobile_no' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('email')">Email
                                                <span>
                                                    <i v-if="meta.keyword=='email' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='email' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('gst_no')">GSTIN
                                                <span>
                                                    <i v-if="meta.keyword=='gst_no' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.keyword=='gst_no' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th class="text-center" v-if="get_activity.length>0">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(vendor,key) in vendors" :key="key">
                                            <td class="text-center">{{meta.from+key}}</td>
                                            <td>{{ vendor.vendor_no }}</td>
                                            <td>{{ vendor.vendor_name }}</td>
                                            <td>{{ vendor.contact_person }}</td>
                                            <td>{{ $mask(vendor.mobile_no) }}</td>
                                            <td>{{ vendor.email }}</td>
                                            <td>{{ vendor.gst_no }}</td>
                                            <td class="text-center" v-if="!meta.trashed && get_activity.length>0">
                                                <button v-can="'vendors.update'" class="btn btn-xs btn-outline-success" data-toggle="tooltip" data-placement="bottom" title="Edit">
                                                    <i class="fas fa-pencil-alt" @click="edit(vendor)"></i>
                                                </button>
                                                <button v-can="'vendors.delete'" class="btn btn-xs btn-outline-danger" data-toggle="tooltip" data-placement="bottom" title="Delete" @click="deleteVendor(vendor)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                            <td class="text-center" v-if="meta.trashed && get_activity.length>0">
                                                <button v-can="'vendors.delete'" class="btn btn-xs btn-outline-success" @click="deleteVendor(vendor)" data-toggle="tooltip" data-placement="bottom" title="Trash">
                                                    <i class="fas fa-trash-restore"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="vendors.length <= 0">
                                            <td colspan="20" style="text-align: center;">No Records Found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                                <div class="float-right">
                                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        name: "Vendor.Index",
        components: { Pagination },
        data() {
            return {
                status: true,
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "vendor_no",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                    trashed: false,
                    branch_id:this.$store.getters.user.branch_id
                },
                vendors: [],
                errors: [],
                get_activity:[],
            };
        },
    mounted() {
            this.get_activity = this.$store.getters.permissions.filter(function (element) {
                return element.ability.ability.includes("vendors.update") || element.ability.ability.includes("vendors.delete");
            });
            let vm = this;
            vm.index();
        },

        methods: {

            index() {
                let vm = this;
                vm.$store.dispatch("post", { uri: "paginateVendors", data: vm.meta })
                .then(function (response) {
                    vm.vendors = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            deleteVendor(vendor) {
                if (confirm("Do you want to continue... ?")) {
                    let vm = this;
                    let loader = vm.$loading.show();
                    let uri = { uri: "deleteVendor", data: vendor };
                    vm.$store.dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Vendor is successfully deleted");
                        vm.index();
                        vm.trashed();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
                }
            },

            edit(vendor) {
                this.$router.push("/vendors/" + vendor.vendor_id + "/edit");
            },

            search(){
               let vm = this;
               vm.meta.page = 1;
               vm.index();
            },
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by=='asc' ? 'desc' : 'asc';
                this.index();
            },
            isTrashed() {
                let vm = this;
                vm.meta.trashed = !vm.meta.trashed;
                if(vm.meta.trashed) {
                    vm.meta.page = 1
                }
                vm.index();
            },
        },
    };
</script>